import { ConfigProvider, Slider } from 'antd'
import { FC, useEffect, useState } from 'react'

interface TtsVolumeProps {
  audio: HTMLAudioElement | null
}

const color = window.location.origin.includes('happyexperts')
  ? 'var(--icon-color)'
  : 'var(--color-primary)'

export const TTSVolume: FC<TtsVolumeProps> = ({ audio }) => {
  const [volume, setVolume] = useState(0.3)

  const handleVolumeChange = (event: number) => setVolume(event)

  useEffect(() => {
    if (audio) {
      audio.volume = volume
    }
  }, [volume, audio])

  return (
    <div style={{ width: 100 }}>
      <ConfigProvider
        theme={{
          components: {
            Slider: {
              handleSize: 13,
              handleColor: color,
              dotActiveBorderColor: color,
              handleActiveColor: color,
              colorPrimaryBorderHover: color,
              trackBg: color,
            },
          },
        }}
      >
        <Slider
          max={1}
          min={0}
          step={0.1}
          value={volume}
          onChange={handleVolumeChange}
        />
      </ConfigProvider>
    </div>
  )
}
